import {authFetch, checkStatus} from '../../utils/http';
import config from '../../../config';

export default class LiveMandateService {
  getMandates(organisationId) {
    return authFetch(`${config.mandateApi}/api/v1/collection-mandates/organisations/${organisationId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getMandateFieldsBySubtype(subtypeCode, thirdPartyGroup) {
    let url = `${config.mandateApi}/api/v1/collection-mandates/fields?subtypeCode=${subtypeCode}`;
    if (thirdPartyGroup) {
      url += `&thirdPartyGroup=${thirdPartyGroup}`;
    }
    return authFetch(url)
      .then(checkStatus)
      .then(response => response.json());
  }

  getMandateDetails(mandateId) {
    return authFetch(`${config.mandateApi}/api/v1/collection-mandates/${mandateId}`)
      .then(checkStatus)
      .then(response => response.json());
  }
}
